jQuery(document).ready(function ($) {
  $('.buttons-upwards').on('click', function(e) {
    // console.log('ok');
    $('body .footer__content-top .shopify-block.shopify-app-block .eu-wbs-button button').click();
  });
  // $('.buttons-upwards').click(function (e) { 
  //   e.preventDefault();
  //   $(this).click('.shopify-block.shopify-app-block .eu-wbs-button');
  // });
  $('footer .has-dropdown .footer-block__heading').click(function (e) { 
    e.preventDefault();
    $(this).toggleClass('active');
  });
  let testimonialSwiper = null;
  function slider_mobile() {
    if($(window).width() <= 949){ 
        if (!testimonialSwiper) {

            testimonialSwiper = new Swiper('.testimonials-slider', {
                slidesPerView: 1,
                spaceBetween: 20,
                loop: true,
                centeredSlides: true,
                pagination: {
                    el: '.testimonials-slider .swiper-pagination',
                    clickable: true
                },
                autoplay: {
                    delay: 50000,
                    disableOnInteraction: false
                }
            });

        }
      const $collection_featured = $(".collection-section ul.product-grid").flickity({
          prevNextButtons: false,
          groupCells: true,
          cellAlign: 'left',
          contain: true,
          pageDots: true,
          // autoPlay: 6000
      });
      const $nt_geeignet = $(".nt_geeignet .multicolumn-list").flickity({
          prevNextButtons: false,
          groupCells: true,
          cellAlign: 'left',
          contain: true,
          pageDots: true,
          // autoPlay: 6000
      });
      const $nt_trendprodukt = $(".nt_trendprodukt .static-items").flickity({
          prevNextButtons: false,
          groupCells: true,
          cellAlign: 'left',
          contain: true,
          pageDots: true,
          // autoPlay: 6000
      });
    }
  }
  $(document).ready(slider_mobile);
  $(window).on('resize', function() {
    slider_mobile();
  });

  $('.fragen_zum_nt').on('click', function() {
    $('#fragen-popup')
      .css('display', 'flex')  
      .hide()                 
      .fadeIn(200);           
  });

  
  $('.popup-close').on('click', function() {
    $('#fragen-popup').fadeOut(200);
  });

  $('#fragen-popup').on('click', function(e) {
    if (e.target === this) {
      $('#fragen-popup').fadeOut(200);
    }
  });

  $('.share-product-btn').on('click', function() {
    $('#teilen-popup')
      .css('display', 'flex')  
      .hide()                 
      .fadeIn(200);           
  });

  
  $('.popup-close').on('click', function() {
    $('#teilen-popup').fadeOut(200);
  });

  $('#teilen-popup').on('click', function(e) {
    if (e.target === this) {
      $('#teilen-popup').fadeOut(200);
    }
  });
  
  $('.testimonials-down').click(function (e) { 
      e.preventDefault();
      $(this).hide();
      $('.testimonials-slider').toggleClass('testimonials-lm');
  });
  $('.acc-head').on('click', function() {
    if($(this).hasClass('active')) {
      $(this).siblings('.acc-content').slideUp();
      $(this).removeClass('active');
    }
    else {
      $('.acc-content').slideUp();
      $('.acc-head').removeClass('active');
      $(this).siblings('.acc-content').slideToggle();
      $(this).toggleClass('active');
    }
  });
});
// load varaint 
window.addEventListener("load", function () {
  const header = document.querySelector('.shopify-section-header-sticky');
  if (!header) return;

  function checkScroll() {
    header.classList.toggle('is-scrolled', window.scrollY > 0);
  }

  checkScroll();
  window.addEventListener('scroll', checkScroll);
});


document.addEventListener('DOMContentLoaded', function () {

    const track = document.querySelector('.nt_trust_icons_pdp .quality-track');

    if (!track) return;

    // Speed in pixels per second
    const speed = 60;

    // Half of the total width (because the content is duplicated)
    const distance = track.scrollWidth / 2;

    // Calculate animation duration
    const duration = distance / speed;

    track.style.animationDuration = `${duration}s`;

});